<app-navbar-style></app-navbar-style>

<router-outlet></router-outlet>

<app-footer *ngIf="!(location == '/coming-soon')"></app-footer>
<ngx-scrolltop *ngIf="!(location == '/coming-soon')"></ngx-scrolltop>
